import { render, staticRenderFns } from "./Oversea.vue?vue&type=template&id=92689e7e"
import script from "./Oversea.vue?vue&type=script&lang=js"
export * from "./Oversea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports